var _desc, _style, _path, _path2, _path3, _path4, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDarkText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "HSBC_x5F_MASTERBRAND_x5F_LOGO_x5F_WW_x5F_CMYK",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 809.7 425.2",
    style: {
      enableBackground: "new 0 0 809.7 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "HSBC logo")), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .st0 {\n            fill: #ffffff;\n        }\n        .st1 {\n            fill: #db0011;\n        }\n        .st2 {\n            fill: none;\n        }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487.4,216.9h-25.7v25.4h-12.9v-59.3h12.9v24.3h25.7v-24.3h12.9v59.3h-12.9V216.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M531.1,243.4c-12.8,0-23.3-5.1-23.6-19.3h12.9c0.2,6.3,3.9,10.1,10.9,10.1c5.3,0,11.2-2.6,11.2-8.5c0-4.6-4-6.1-10.7-8l-4.3-1.2c-9.4-2.7-18.6-6.3-18.6-17c0-13.2,12.3-17.6,23.6-17.6c11.6,0,21.5,4,21.6,17.2h-12.9c-0.5-5.4-3.6-8.5-9.7-8.5c-4.8,0-9.5,2.5-9.5,7.8c0,4.3,3.9,5.7,12.3,8.3l4.9,1.6c10.2,3.2,16.6,6.7,16.6,16.6C555.8,238.2,542.8,243.4,531.1,243.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M563.1,182.9h20.6c6.5,0,9.1,0.2,11.7,0.7c7.2,1.6,12.6,6.3,12.6,14.3c0,7.6-4.8,11.6-11.8,13.4c8,1.5,14,5.6,14,14.4c0,13.5-13.3,16.6-23.7,16.6h-23.3V182.9z M583.8,207.6c5.7,0,11.4-1.1,11.4-8c0-6.2-5.4-7.8-10.6-7.8h-9v15.8H583.8z M585,233.4c6,0,11.9-1.4,11.9-8.6c0-7.1-5.1-8.7-11.2-8.7h-10.2v17.3H585z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M643.7,243.4c-19.1,0-27.7-12.2-27.7-30.3c0-17.9,9.5-31.3,28.4-31.3c11.8,0,23.3,5.3,23.6,18.7h-13.3c-0.7-5.9-4.6-9-10.3-9c-11.6,0-15.1,12.5-15.1,22c0,9.4,3.5,20.4,14.7,20.4c5.8,0,10.1-3.1,11-9.1h13.4C666.9,238.3,656,243.4,643.7,243.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 141.7,
    className: "st0",
    width: 141.7,
    height: 141.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "354.3,283.5 425.2,212.6 354.3,141.7 354.3,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "212.6,283.5 141.8,212.6 212.6,141.7 212.6,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "354.3,141.7 283.5,212.6 212.6,141.7 212.6,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "212.6,283.5 283.5,212.6 354.3,283.5 354.3,283.5  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st2",
    width: 809.7,
    height: 425.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkText);
export default __webpack_public_path__ + "static/media/LogoDarkText.1f3dfff5.svg";
export { ForwardRef as ReactComponent };